import React from "react";

const TREND_CONFIG = {
  Worsening: { color: "#e24b4a", bg: "#fef2f2", arrow: "↗" },
  Watch:     { color: "#ba7517", bg: "#faeeda", arrow: "→" },
  Improving: { color: "#1a9e78", bg: "#e1f5ee", arrow: "↘" },
};

// Each week value maps to a badge color based on score
const weekBadgeColor = (val) => {
  if (val === 0) return { bg: "#e1f5ee", color: "#0f6e56" };
  if (val <= 1)  return { bg: "#e1f5ee", color: "#0f6e56" };
  if (val <= 2)  return { bg: "#faeeda", color: "#633806" };
  return              { bg: "#fef2f2", color: "#a32d2d" };
};

const WeekBadge = ({ week, val }) => {
  const { bg, color } = weekBadgeColor(val);
  return (
    <div style={{ textAlign: "center" }}>
      <div style={{
        width: 32, height: 32, borderRadius: 6,
        background: bg, color, fontWeight: 500, fontSize: 15,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        {val}
      </div>
      <div style={{ fontSize: 9, color: "#aab0be", marginTop: 3 }}>{week}</div>
    </div>
  );
};

const VesselRiskRow = ({ name, trend, weeks, current }) => {
  const cfg = TREND_CONFIG[trend] || TREND_CONFIG.Watch;
  return (
    <div style={{
      background: "#fff", border: "0.5px solid #e2e4e8",
      borderRadius: 8, padding: "12px 16px", marginBottom: 10,
    }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <div style={{ fontSize: 13, fontWeight: 500, color: "#1a1e2e", marginBottom: 5 }}>{name}</div>
          <span style={{
            fontSize: 11, fontWeight: 500, padding: "2px 8px",
            borderRadius: 20, background: cfg.bg, color: cfg.color,
            display: "inline-flex", alignItems: "center", gap: 4,
          }}>
            {cfg.arrow} {trend}
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {weeks.map((w, i) => (
            <WeekBadge key={i} week={`WEEK ${i + 1}`} val={w} />
          ))}
          <div style={{ textAlign: "center", marginLeft: 6 }}>
            <div style={{
              width: 36, height: 36, borderRadius: 6,
              background: "#1a1e2e", color: "#fff",
              fontWeight: 500, fontSize: 18,
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              {current}
            </div>
            <div style={{ fontSize: 9, color: "#aab0be", marginTop: 3 }}>CURRENT</div>
          </div>
        </div>
      </div>
    </div>
  );
};

const RiskOverview = ({ vessels }) => {
  const data = vessels || [
    { name: "FLORA SCHULTE",     trend: "Worsening", weeks: [0, 1, 2, 3], current: 3 },
    { name: "FRIEDRICH SCHULTE", trend: "Watch",     weeks: [0, 1, 2, 3], current: 3 },
    { name: "FREYA SCHULTE",     trend: "Improving", weeks: [0, 1, 3, 2], current: 2 },
  ];

  return (
    <div style={{
      background: "#f5f6f8", border: "0.5px solid #e2e4e8",
      borderRadius: 10, padding: 16,
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5a6070" strokeWidth="2">
          <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/>
          <line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/>
          <line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
        </svg>
        <span style={{ fontSize: 14, fontWeight: 500, color: "#1a1e2e" }}>Risk Overview</span>
      </div>
      {data.map((v, i) => (
        <VesselRiskRow key={i} {...v} />
      ))}
    </div>
  );
};

export default RiskOverview;